// plugins/initAuth.js
export default defineNuxtPlugin(async (nuxtApp) => {
  const authStore = useAuthStore(nuxtApp.$pinia)
  if (!process.server) {
    // Client-side
    await authStore.getTwitterProfile()
  }
})
